import { Injectable, Provider } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { AuthCryptoService } from './auth-crypto.service';

@Injectable()
export class _AuthKeyInterceptor implements HttpInterceptor {

  private readonly protectedPaths: string[] = [
    '/api/auth/loginx/',
    '/api/auth/registerx/'
  ];

  private readonly keyBootstrap = /^\/api\/auth\/enc-sym-key\b/i;

  constructor(
    private crypto: AuthCryptoService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Skip non-API or non-matching requests outright
    const url = req.url || '';
    const needsKey = this.protectedPaths.some(path => url.includes(path))
    const isBootstrap = this.keyBootstrap.test(url);

    if (!needsKey || isBootstrap) {
      return next.handle(req);
    }

    const cipherText = this.crypto.encryptPayload(req.body ?? {});
    const reqEncrypted = req.clone({ body: cipherText });
    return next.handle(reqEncrypted).pipe(
      tap(this.handleError.bind(this))
    );
  }

  handleError(response: HttpEvent<any>) {

    if (!(response instanceof HttpResponse)) return;

    if (
      response.body.message === 'Encryption failed'
      || response.body.status === 'FAILURE'
    ) {
      throw response;
    }
  }

}

export const AuthKeyInterceptor: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: _AuthKeyInterceptor,
  multi: true
}
